import request from '@/utils/request'
// 插件列表
export function list (params) {
  return request({
    url: '/codeStoreFront/list',
    method: 'get',
    params: params
  })
}

// 插件详情
export function one (id) {
  return request({
    url: '/codeStoreFront/one',
    method: 'get',
    params: {
      id
    }
  })
}

// 插件版本信息
export function getPluginVertionInfo (id) {
  return request({
    url: '/codeStoreFront/getPluginVertionInfo',
    method: 'get',
    params: {
      vertionId: id
    }
  })
}

// 获取插件分类
export function getPlugincate () {
  return request({
    url: '/codeStoreFront/getPlugincate',
    method: 'get',
    params: {}
  })
}

// 获取下载信息
export function getDownLoadInfo (query) {
  return request({
    url: '/codeStoreFrontAdmin/getDownloadInfo',
    method: 'get',
    params: query
  })
}
// 获取授权信息
export function getImpowerInfo (query) {
  return request({
    url: '/codeStoreFrontAdmin/getImpowerInfo',
    method: 'get',
    params: query
  })
}
// 添加授权
export function addImpower (data) {
  return request({
    url: '/codeStoreFrontAdmin/addImpower',
    method: 'post',
    data: data
  })
}

// 获取协议信息
export function getAgreementInfo () {
  return request({
    url: '/codeStoreFront/getAgreement',
    method: 'get'
  })
}

// 下载插件
export function downloadPlugin (url) {
  window.location.href = url
  /* const loading = Loading.service({
    lock: true,
    text: '正在获取插件数据...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  axios({
    url: url,
    method: 'get',
    responseType: 'blob'
  }).then(res => {
    loading.close()
    if (res.status !== 200) {
      Message({
        message: '发生错误，导出失败。',
        type: 'error'
      })
      return
    }
    const reader = new FileReader()
    reader.readAsText(res.data)
    reader.onload = () => {
      // 获取读取的文本内容
      const text = reader.result
      try {
        // 将文本内容转换为JSON对象
        const json = JSON.parse(text)
        // 现在你可以使用json对象了
        if (json && json.code !== 0) {
          Message({
            message: json.msg,
            type: 'error'
          })
          return
        }
      } catch (e) {
        console.log(e)
      }

      try {
        const aLink = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/zip' })
        // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
        const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
        const contentDisposition = decodeURI(res.headers['content-disposition'] || res.headers['Content-Disposition'])
        const result = patt.exec(contentDisposition)
        let fileName = result[1]
        fileName = fileName.replace(/"/g, '')
        aLink.href = URL.createObjectURL(blob)
        aLink.setAttribute('download', fileName) // 设置下载文件名称
        document.body.appendChild(aLink)
        aLink.click()
        document.body.appendChild(aLink)
      } catch (e) {
        console.log(e)
        Message({
          message: e.message,
          type: 'error'
        })
      }
    }
  }) */
}
